import { render, staticRenderFns } from "./local-case-validation-situations-modal.vue?vue&type=template&id=96457400&scoped=true&"
import script from "./local-case-validation-situations-modal.ts?vue&type=script&lang=ts&"
export * from "./local-case-validation-situations-modal.ts?vue&type=script&lang=ts&"
import style0 from "./local-case-validation-situations-modal.scss?vue&type=style&index=0&id=96457400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96457400",
  null
  
)

export default component.exports